import { useCallback, useMemo } from "react";

import { type FetchResult, useMutation } from "@apollo/client";

import { type TosKey } from "../../gql-generated/types";
import {
    type SetTosLatestAcceptedVersionMutation,
    setTosLatestAcceptedVersion as setTosLatestAcceptedVersionMutation,
} from "../api/mutations";
import { type ApolloResult } from "../models";

export interface SetTosResult {
    setTosLatestAcceptedVersion: () => Promise<FetchResult<SetTosLatestAcceptedVersionMutation>>;
}
export const useSetTos = (tosKey: TosKey): ApolloResult<SetTosResult> => {
    const [tosLatestAcceptedVersionSetter, { loading, error }] = useMutation<SetTosLatestAcceptedVersionMutation>(
        setTosLatestAcceptedVersionMutation,
    );

    const setTosLatestAcceptedVersion = useCallback(
        () => tosLatestAcceptedVersionSetter({ variables: { key: tosKey } }),
        [tosLatestAcceptedVersionSetter, tosKey],
    );

    return useMemo(
        () => ({
            loading,
            error,
            setTosLatestAcceptedVersion,
        }),
        [loading, error, setTosLatestAcceptedVersion],
    );
};
